/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeProxyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ProxyAdmin__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ProxyAdmin__factory.bytecode = _bytecode;
ProxyAdmin__factory.abi = _abi;
